import { AppAlert, AppBadge, AppDialog } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { TagSelect } from '@opportunities/list/-components/TagSelect'
import { useState } from 'react'
import { getTagGroupColor, TAG_GROUP_LABELS } from '@/lib/tag-utils'
import { useTagsDialog } from './hooks/useTagsDialog'

/**
 * TagsDialog コンポーネントの Props
 */
interface TagsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  opportunity: {
    id: number
    title: string
  } | null
}

/**
 * TagsDialog - オポチュニティのタグ編集ダイアログ
 *
 * オポチュニティに紐づくタグの追加・削除を行うダイアログコンポーネント
 */
export function TagsDialog({ open, onOpenChange, opportunity }: TagsDialogProps) {
  const { selectedTags, setSelectedTags, isPending, handleSave } = useTagsDialog(open, onOpenChange, opportunity)
  const [hasValidationError, setHasValidationError] = useState(false)

  if (!opportunity) return null

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title='タグ編集'
      isPending={isPending}
      className='max-w-2xl max-h-[90vh] flex flex-col'
      footerOptions={[
        { label: 'キャンセル', onClick: () => onOpenChange(false), variant: 'outline' },
        {
          label: '保存',
          variant: 'save' as const,
          onClick: handleSave,
          isPending: isPending,
          isPendingText: '保存中...',
          disabled: hasValidationError,
        },
      ]}
    >
      <div className='flex-1 overflow-y-auto space-y-4'>
        <AppAlert type='info'>
          <div className='mb-2'>新規タグには接頭語を追加することでグループを宣言することができます</div>
          <div className='flex flex-wrap gap-2'>
            {Object.entries(TAG_GROUP_LABELS).map(([group, label]) => (
              <AppBadge key={group} color='none' className={getTagGroupColor(group)}>
                {group}:{label}
              </AppBadge>
            ))}
            <AppBadge color='none' className={getTagGroupColor(null)}>
              未設定
            </AppBadge>
          </div>
        </AppAlert>

        <AppAlert type='info'>{`オポチュニティ 「${opportunity.title}」 に紐づくタグを指定します。`}</AppAlert>

        <TagSelect
          value={selectedTags}
          onChange={setSelectedTags}
          label='オポチュニティタグを指定（複数指定可）'
          placeholder='タグを検索または新規入力...'
          allowCreate
          helpText='既存タグから選択するか、新しいタグを入力してEnterキーで追加してください。グループを指定する場合は「group:名前」の形式で入力します。'
          onValidationChange={setHasValidationError}
        />
      </div>
    </AppDialog>
  )
}
